var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292787 1.29357C0.480314 1.1061 0.734622 1.00078 0.999786 1.00078C1.26495 1.00078 1.51926 1.1061 1.70679 1.29357L4.99979 4.58657L8.29279 1.29357C8.38503 1.19806 8.49538 1.12188 8.61738 1.06947C8.73939 1.01706 8.87061 0.989473 9.00339 0.988319C9.13616 0.987165 9.26784 1.01247 9.39074 1.06275C9.51364 1.11303 9.62529 1.18728 9.71918 1.28117C9.81307 1.37507 9.88733 1.48672 9.93761 1.60962C9.98789 1.73251 10.0132 1.86419 10.012 1.99697C10.0109 2.12975 9.9833 2.26097 9.93089 2.38297C9.87848 2.50498 9.8023 2.61532 9.70679 2.70757L5.70679 6.70757C5.51926 6.89504 5.26495 7.00036 4.99979 7.00036C4.73462 7.00036 4.48031 6.89504 4.29279 6.70757L0.292787 2.70757C0.105316 2.52004 0 2.26573 0 2.00057C0 1.73541 0.105316 1.4811 0.292787 1.29357Z",
    fill: "#08090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownActive);
export default __webpack_public_path__ + "static/media/dropdownActive.0d211ae6de26ae5cb2b32b47b40dec42.svg";
export { ForwardRef as ReactComponent };